<template>
  <modal
    class="new-editor-modal timeless-offer-interval-modal"
    name="timeless-offer-interval-modal"
    @before-open="handleBeforeOpen"
    transition="fade"
    :adaptive="true"
    :scrollable="true"
    :reset="true"
    width="60%"
    height="auto"
    style="z-index: 2001;"
  >
    <div id="modal-header"  class="action-modal">
      <div class="w-100 d-flex text-left">
        <p class="text-left">Սահմանել քանակների շեմեր և դրանց համապատասխան գներ</p>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 25%"
              @click="$modal.hide('timeless-offer-interval-modal')"
              aria-label="Close"
      >
          <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5 1.64102L14.859 0L8.49997 6.359L2.14102 4.62582e-05L0.5 1.64107L6.85895 8.00002L0.500034 14.3589L2.14105 16L8.49997 9.64104L14.8589 16L16.5 14.359L10.141 8.00002L16.5 1.64102Z" fill="#ABAEB8"/>
          </svg>
      </button>
    </div>
    <div id="modal-body" class="padding-20">
<!--      <div class="d-flex p-0 col-auto">-->
<!--        <p class="mr-2" style="font-size: 16px">-->
<!--          Ընդհանուր քանակ` <span style="color: #006BE6; font-weight: 600">{{totalCount}}</span>-->
<!--        </p>-->
<!--      </div>-->
      <div class="interval-block d-flex flex-column">
        <div v-for="(intervalRow, index) in intervalRows" :key="index" class="interval-row d-flex w-100 padding-b-20">
          <div class="w-fit py-2 d-flex align-items-end">
            <div class="d-flex align-items-center" >
              <button @click="addRow(index)" type="button"
                      class="btn btn-primary"
                      :style="((index !== intervalRows.length - 1) || index === 4) && 'opacity: 0;'"
              >
                <i class="fa fa-plus" aria-hidden="true"></i>
              </button>
            </div>
          </div>
          <div class="w-100 flex-column d-flex justify-content-center align-items-center padding-l-10 padding-r-10">
            <div class="d-flex p-0 col-auto">
              <p class="mr-2">
                Նվազագույն քանակ
              </p>
            </div>
            <input
                v-model.number="intervalRow.min_count"
                v-integer-only
                placeholder="Նվազագույն քանակ"
                type="text"
                name="unit"
                class="tender-input col-auto m-0"
            />
          </div>
          <div class="w-100 flex-column d-flex justify-content-center align-items-center padding-l-10 padding-r-10">
            <div class="d-flex p-0 col-auto">
              <p class="mr-2">
                Առավելագույն քանակ
              </p>
            </div>
            <input
                v-model.number="intervalRow.max_count"
                v-integer-only
                @input="(e) => handleCountChange(e, index)"
                placeholder="Առավելագույն քանակ"
                type="text"
                name="unit"
                class="tender-input col-auto m-0"
            />
            <span v-if="intervalRow.countGreaterThenTotal"  class="small m-0 helper-text text-danger font-weight-bold">Նշված  քանակը մուտաքգրված քանակից շատ է</span>
          </div>
          <div class="d-flex  w-100">
            <div class="d-flex justify-content-center align-items-center">
              <div style="width: 200px" class="flex-column d-flex align-items-center padding-l-10 padding-r-10">
                <div class="d-flex p-0 col-auto">
                  <p class="mr-2">
                    Միավորի գին
                  </p>
                </div>
                <input
                    v-model.number="intervalRow.price"
                    v-integer-only
                    style="color: #006BE6; font-weight: 600"
                    @input="(e) => handlePriceChange(e, index)"
                    placeholder="Միավորի գին"
                    type="number"
                    class="tender-input w-100 m-0"
                    id="procurement-name-ru"
                >
                <span v-if="intervalRow.priceGreaterThenMarket" class="small m-0 helper-text text-danger font-weight-bold">Նշված գինը գերազանցում է շուկայական գինը</span>
                <span v-if="intervalRow.equalPrice"  class="small m-0 helper-text text-danger font-weight-bold">Նշված գինը հավասար է ներկայացված գներից մեկին</span>
              </div>
              <div class="flex-column d-flex align-items-center justify-content-center padding-l-10 padding-r-10">
                <div class=" p-0 col">
                    ԱԱՀ-ով
                </div>
                <input
                    class="m-0"
                    v-model="intervalRow.is_with_vat"
                    @change="(e) => handleVatChange(e, index)"
                    :true-value="true"
                    :false-value="false"
                    type="checkbox">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="modal-footer">
      <button @click="confirm" :disabled="loading" type="button" class="btn btn-primary">
        <span v-if="loading" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
        <span>Պահպանել</span>
      </button>
    </div>
  </modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'


export default {
    name: 'TimelessOfferIntervalModal',
    props: ['lastOffers', 'marketPrice', 'totalCount'],
    data() {
      return {
        intervalRows: [
          {
            min_count: 1,
            max_count: null,
            price: null,
            is_with_vat: false,
          }
        ],
        title: '',
        text: false,
        alertMsg: false,
        equalPrice: false,
        callback: null,
        loading: false
      }
    },
    validations() {
      return {
        intervalRows: {
          $each: {
            min_count: { required },
            max_count: { required },
            price: {
              required,
              // validPrice: (value, vm) => {
              //   return !vm.priceGreaterThenMarket && !vm.equalPrice && !vm.countGreaterThenTotal;
              // }
              validPrice: (value, vm) => {
                return !vm.countGreaterThenTotal;
              }
            },
            is_with_vat: { required },
          }
        },
      }
    },
    computed: {
      me() {
        return this.$store.getters['user/me']
      },
    },
    methods: {
      addRow(index) {
        this.intervalRows.push({
          min_count: this.intervalRows[index].max_count,
          max_count: null,
          price: null,
          is_with_vat: false,
        })
      },
      handleCountChange(event, index) {
        const count = +event.target.value
        if (count > this.totalCount) {
          this.intervalRows[index].countGreaterThenTotal = true;
        } else {
          this.intervalRows[index].countGreaterThenTotal = false;
        }
      },
      handlePriceChange(event, index) {
        // let hasEqualPrice = false;
        // const price = +event.target.value
        // const vatPayer = this.me.vat_payer_type === 'payer';
        // if (this.lastOffers.length) {
        //   this.lastOffers.forEach((offer) => {
        //     const offerPrice = vatPayer ? +offer.price : +offer.total_price;
        //     if (+offerPrice === price) {
        //       if (offer && offer.user_id !== this.me.id) {
        //         hasEqualPrice = true;
        //       }
        //     }
        //   });
        // }
        //
        // if (+price > +this.marketPrice) {
        //   this.intervalRows[index].priceGreaterThenMarket = true;
        // } else {
        //   this.intervalRows[index].priceGreaterThenMarket = false;
        // }
        // this.intervalRows[index].equalPrice = hasEqualPrice;
      },
      handleVatChange(event, index) {
        if (event.target.checked) {
          this.intervalRows[index].price = this.intervalRows[index].price * 1.2;
        } else {
          this.intervalRows[index].price = this.intervalRows[index].price - (this.intervalRows[index].price / 6);
        }
      },
      handleBeforeOpen({ params }) {
        this.loading = false
        console.log(params)
        if(params?.priceIntervalArray?.length){
          this.intervalRows = params.priceIntervalArray;
        } else {
          this.intervalRows = [
            {
              min_count: 1,
              max_count: this.totalCount,
              price: null,
              is_with_vat: false,
            }
          ];
        }
        this.callback = params.callback;
      },
      confirm() {
        this.loading = true;
        console.log(this.intervalRows);
        this.intervalRows[this.intervalRows.length - 1].max_count = this.totalCount
        if (!this.$v.intervalRows.$invalid) {
          this.callback(this.intervalRows);
        } else {
          this.$notify({
            group: 'foo',
            type: 'error',
            text: 'Լրացրեք բոլոր դաշտերը հաստատելու համար!'
          })
          this.loading = false;
        }
      }
    }
  }
</script>
<style>
  .tab {
      margin-left: 25px;
  }
</style>
<style scoped>

</style>
